import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import '../style.scss';
import Header from 'components/Header';
import MenuT from 'components/Menu';

import './style.css';

const AUX = ({
  WrappedComponent
}) => {
  const [collapsed, setCollapsed] = useState(false);
  
  return (
    <div id="wrapper">
      <Header collapsed={collapsed}/>
      <MenuT collapsed={collapsed} setCollapsed={setCollapsed}/>
      <div className={"content-page"+(!!collapsed?' collapsed':'')}>
        <div className="content">
          <WrappedComponent></WrappedComponent>
        </div>
      </div>
    </div>
  );
};

const MasterPage = WrappedComponent => {
  return connect()(props => {
    
    return (
      <AUX WrappedComponent={WrappedComponent}/>
    );
  });
};

export default MasterPage;
